import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import AppState from "./context/AppState";
import { Slug } from "./constants/Slug";

// Set scroll restoration to manual
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppState>
      <BrowserRouter basename={Slug}>
        <App />
      </BrowserRouter>
    </AppState>
  </React.StrictMode>
);

reportWebVitals();
